import { z } from 'zod';
import { WatchedAlertRuleSchema } from '../base.js';
export const GetWatchedRulesRequestSchema = z.void();
export const GetWatchedRulesResponseSchema = WatchedAlertRuleSchema.array();
